const ErrorUtil = {
    pushErrorToPlumbrAndLog(error, serviceName) {
        var _a;
        !!serviceName && ((_a = window.PLUMBR) === null || _a === void 0 ? void 0 : _a.startTransaction(serviceName));
        this.pushErrorToPlumbr(error);
        console.error(error);
    },
    pushErrorToPlumbr(error) {
        var _a, _b, _c, _d, _e, _f;
        if (window.PLUMBR) {
            if (error === null || error === void 0 ? void 0 : error.config) {
                const e = error;
                const errorBody = ((_c = (_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.length) && ((_d = e.response.data.errors[0]) === null || _d === void 0 ? void 0 : _d.body);
                error.stack = `${e === null || e === void 0 ? void 0 : e.message}, ${(_e = e === null || e === void 0 ? void 0 : e.config) === null || _e === void 0 ? void 0 : _e.method}:${(_f = e === null || e === void 0 ? void 0 : e.config) === null || _f === void 0 ? void 0 : _f.url} \n message: ${errorBody} \n ${e.stack}`;
            }
            window.PLUMBR.sendError(error);
        }
    }
};
export default ErrorUtil;
